/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Rounds_Seating_UnseatInputs */



/**
* | output |
* | --- |
* | "Remove {name} from the round" |
*
* @param {Rounds_Seating_UnseatInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seating_unseat = /** @type {((inputs: Rounds_Seating_UnseatInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seating_UnseatInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Retirer ${i?.name} de la ronde`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Quitar a ${i?.name} de la ronda`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Remover ${i?.name} da rodada`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Rimuovi ${i?.name} dal round`)
	return /** @type {LocalizedString} */ (`Remove ${i?.name} from the round`)
});